import React, { forwardRef } from "react";
import accessibleDropdown from "../AccessibleDropdown/AccessibleDropdown";
import { Link } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import UserStore from "../../store/UserStore";
import { getDecodedToken, getDisplayDate } from "../../utils/functions";

const ReportsMenuList = forwardRef(
  (
    {
      menuItems,
      itemRefs,
      isOpen,
      handleItemKeyDown,
      handleMenuItemClick,
      restrictHover,
      accessibilityValues,
      handleClick,
      popupClassName = { open: "", close: "", wrapperClass: "" },
    },
    ref,
  ) => {
    const decodedToken = getDecodedToken();

    const getDefaultImage = (name) => {
      if (!name) return;
      return <div className="profileImageDefault2">{name[0]}</div>;
    };

    const getProfileImage = () => {
      if (decodedToken?.user_type === "manager") {
        if (UserStore.userData?.profile_pic && UserStore.singleUsersUrl) {
          return (
            <img
              className="profile"
              src={UserStore.singleUsersUrl}
              alt="profile"
            />
          );
        } else {
          return getDefaultImage(UserStore.userData?.full_name);
        }
      } else {
        if (
          UserStore.currentFamilyMembers?.find(
            (item) => item.user_id === UserStore.selectedUsersId,
          )?.profile_pic &&
          UserStore.singleUsersUrl
        ) {
          return (
            <img className="profile" src={UserStore.singleUsersUrl} alt="" />
          );
        } else {
          return getDefaultImage(UserStore.userData?.full_name);
        }
      }
    };

    function getMemberSinceDate() {
      const isPrimary = getCookie("isSelectedUserPrimary");
      const inceptionDates = getCookie("inceptionDates");

      // Primary users inception date and that families family inception date is same,
      // Then 1. Primary clients login , 2. Employee / Liaison login and Primary member selected from all available families , we display , families inception date , even if we change the client from global "All Member" button
      // Otherwise display Clients inception date if non primary is choosen from the families screen or the login is of non-primary member itself

      if (isPrimary && !JSON.parse(isPrimary))
        return inceptionDates?.client_inceptiondate;
      else return inceptionDates?.family_inceptiondate;
    }

    const getNavigationPath = (menuItem) => {
      const path = menuItem.navigateTo
        ? menuItem.navigateTo
        : decodedToken?.user_type === "employee"
          ? menuItem.employeeNavigation.navigateTo
          : menuItem.familyOfficeNavigation.navigateTo;
      return path;
    };

    return (
      <>
        <div
          className={`popup_menu ${isOpen ? popupClassName.open : popupClassName.close}`}
        >
          <p className="profile_menu_heading">
            Member since {getDisplayDate(getMemberSinceDate())}
            <span>{UserStore.usersData}</span>
          </p>
          <div
            id={accessibilityValues.ariaControls}
            role={accessibilityValues.ariaHaspopup}
            aria-label={accessibilityValues.ariaLabel}
            aria-labelledby={accessibilityValues.buttonId}
            ref={ref}
            className="profile_listitem_container"
          >
            {menuItems?.map((menuItem, index) => {
              return (
                <Link
                  aria-hidden={!isOpen}
                  key={menuItem?.key}
                  ref={(el) => (itemRefs.current[index] = el)}
                  role="menuitem"
                  to={getNavigationPath(menuItem)}
                  state={
                    menuItem?.key === "switchFamily"
                      ? menuItem.stateObject
                      : { isNavigatedFromHeader: true }
                  }
                  onKeyDown={(e) => {
                    handleItemKeyDown(e, index);
                  }}
                  className="listitem with_btn"
                  onClick={() => handleClick(menuItem?.heading)}
                >
                  {menuItem.heading === "View Profile" ? (
                    <button className="list_btn" role="menuitem">
                      {getProfileImage()}{" "}
                      <p className="listitem_text">{getCookie("name")}</p>
                    </button>
                  ) : (
                    <button className="list_btn" role="menuitem">
                      {menuItem?.image && (
                        <div className="icon_wrapper profile-list-icon">
                          {menuItem?.image}
                        </div>
                      )}
                      <p className="listitem_text">{menuItem?.heading}</p>
                    </button>
                  )}
                </Link>
              );
            })}
          </div>
        </div>
      </>
    );
  },
);

export default accessibleDropdown(ReportsMenuList);
